import React from 'react'
import { useState,useEffect } from 'react';
import apiRequests from '../../Component/axios/config/config';
import toast from "react-hot-toast";
import DynamicNavBar from '../../Component/navbars/navbar';
import { IoIosAddCircleOutline } from "react-icons/io";
import { FaFilter } from "react-icons/fa6";
const Crawler = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [showModal,setShowModal]=useState(false)
    const [limit,setLimit]=useState("")
    const [category,setCategory]=useState("")
    const [site,setSite]=useState("")
    const [acivation,setActivation]=useState(false)
    const [categories,setCategories]=useState([])
    const [sites,setSites]=useState([{value:"ایستگاه",key:"istgah"},{value:"نیاز روز",key:"niazrooz"}])
    const [activationStatus,setActivationStatus]=useState([{value:"فعال",key:true},{value:"غیر فعال",key:false}])
    const [categoryId,setCategoryId]=useState(null)
    

    const fetchDatas = async () => {
        setLoading(true);
        try{
              const res=await apiRequests.get("/api/crawler/v1/get-limit-crawler")
            
                setData(res.data.data)
                setLimit(res.data.data[0]?.limit)
               await getCategoryById(res.data.data[0]?.category)
               setCategoryId(res.data.data[0]?.category)
                setSite(res.data.data[0]?.site)
                setActivation(res.data.data[0]?.activition)
               
         

        }
        catch(err){
            console.log(err)
            toast.error("خطا در دریافت اطلاعات");
        }finally{
            setLoading(false);
        }
      
    };

    useEffect(() => {
        fetchDatas();
    }, []);

    const apiLogin = () => {

        apiRequests.get("/api/category/v1/get-all-category")
            .then((res) => {
                setCategories(res.data.data);
             
            })
            .catch(() => { })
         
    };

    useEffect(() => {
        apiLogin();
    }, []);

    const getCategoryById =async (ctg) => {
   
        apiRequests.get(`/api/category/v1/get-category-by-id/${ctg}`
          )
            .then((res) => {
                setCategory(res.data.data.Name);
  
             
            })
            .catch(() => { })
         
    };

 

   

    function handleEditSubmit(){
        setLoading(true);
        const body={
            "id":data[0]._id ,
            "limit":limit ,
            "category": categoryId,
            "site": site,
            "activition": acivation
        }
        console.log(body)
        apiRequests.put("/api/crawler/v1/edit-limit-crawler",body)
            .then((res) => {
    
                toast.success("فیلتر ها با موفقیت اعمال شد");
                fetchDatas()

            })
            .catch((err) => {
            
                toast.error("خطا در فیلتر اطلاعات");
            })
            .finally(() => {
                setLoading(false);
                setTimeout(() => {
                    setShowModal(false)
                }, 200);
         
            });
            

    }


console.log(data)

  return (
    <div>
    <div className="px-6 text-3xl">
        جست و جو گر
    </div>

    <div className="md:flex md:justify-center">

        <div className="bg-primaryColor-shade6 mt-16 md:mt-5 mx-12 md:mx-0  px-3 md:px-0 py-2 rounded-md flex items-center justify-end md:w-11/12  md:flex-col md:gap-y-4 md:py-4">
        

        <div className="flex items-center bg-white rounded-md">
            

            <div onClick={()=>{setShowModal(true)}} className="bg-BlueColor-shade5 text-white p-[5px] rounded-md cursor-pointer">
            <FaFilter></FaFilter>
            </div>

        </div>

        </div>
    </div>




    <div className="flex justify-center mt-8">
        <table className="min-w-[80%]">
            <thead className="bg-secondColor-shade4 text-white text-center">
            <tr>
                <th className="px-4 py-2 text-md md:text-[8px] font-medium rounded-tr-lg">محدودیت</th>
                <th className="px-4 py-2 text-md md:text-[8px] font-medium">سایت</th>
                <th className="px-4 py-2 text-md md:text-[8px] font-medium">دسته بندی</th>
               
                <th className="px-4 py-2 text-md md:text-[8px] font-medium">وضعیت</th>
                <th className="px-4 py-2 text-md md:text-[8px] font-medium">ایجاد</th>
                <th className="px-4 py-2 text-md md:text-[8px] font-medium rounded-tl-lg">ویرایش شده در</th>
              
            </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
            {!loading ? (
                data.length > 0 ? (
                    data?.map((it, index) => (
                        <tr key={index} className="hover:bg-gray-100 md:text-[8px] text-center">
                            <td className="px-4 py-2">{it?.limit || "نامشخص"}</td>
                            <td className="px-4 py-2">{it.site=="niazrooz" ? "نیاز روز":"ایستگاه" || "-"}</td>
                          
                            <td className="px-4 py-2">
                                {category || "-"}
                            </td>
                        
                            
                            <td className="px-4 py-2">
                                {it.acivation ? (
                                    <span className="text-green-600 font-semibold">فعال</span>
                                ) : (
                                    <span className="text-red-600 font-semibold">غیرفعال</span>
                                )}
                            </td>
                            <td className="px-4 py-2">
                                {new Date(it.createdAt).toLocaleDateString("fa-IR")}
                            </td>
                            <td className="px-4 py-2">
                                {new Date(it.updatedAt).toLocaleDateString("fa-IR")}
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr className="text-center">
                        <td className="px-4 py-2" colSpan="6">گزارشی یافت نشد!</td>
                    </tr>
                )
            ) : (
                <tr className="text-center">
                    <td className="px-4 py-2" colSpan="6">در حال بارگیری ...</td>
                </tr>
            )}
            </tbody>
        </table>
    </div>

    {showModal&& (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg">
                        <h2 className="text-xl font-bold mb-4 text-center">اعمال فیلتر</h2>
                        <input
                            type="number"
                            className="w-full border border-gray-300 rounded-md p-2 mb-4"
                            value={limit}
                            min={0}
                            onChange={(e) => setLimit( e.target.value >=0 ?  e.target.value : 0)}
                            placeholder="محدودیت"
                        />

                        <div className="mb-4">
                            <label className="block mb-1 font-medium text-gray-700">دسته بندی ها</label>
                            <select
                            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-green-400"
                            value={categoryId}
                            onChange={(e) => setCategoryId(e.target.value)}
                            >
                                <option>انتخاب کنید</option>
                                {
                                    categories?.map((it,index)=>(
                                        <option value={it._id} key={index}>{it.Name}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className="mb-4">
                            <label className="block mb-1 font-medium text-gray-700">سایت</label>
                            <select
                            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-green-400"
                            value={site}
                            onChange={(e) => setSite(e.target.value)}
                            >
                                <option>انتخاب کنید</option>
                                {
                                    sites?.map((it,index)=>(
                                        <option value={it.key} key={index}>{it.value}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className="mb-4">
                            <label className="block mb-1 font-medium text-gray-700">وضعیت</label>
                            <select
                            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-green-400"
                            value={acivation}
                            onChange={(e) => setActivation(e.target.value)}
                            >
                                <option>انتخاب کنید</option>
                                {
                                activationStatus?.map((it,index)=>(
                                        <option value={it.key} key={index}>{it.value}</option>
                                    ))
                                }
                            </select>
                        </div>

                        <div className="flex justify-between">
                            <button
                                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                                onClick={handleEditSubmit}
                            >
                                اعمال فیلتر
                            </button>
                            <button
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
                                onClick={()=>{setShowModal(false)}}
                            >
                                لغو
                            </button>
                        </div>
                    </div>
                </div>
            )}

    {/* {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white  rounded-lg p-6 w-1/2 h-auto text-center shadow-lg">
                <h2 className="text-xl font-bold mb-4">متن پیام</h2>
                <p className=" border border-blue-950 rounded-[4px] py-2 text-gray-700 mb-6 whitespace-pre-wrap">{selectedMessage || "پیامی موجود نیست"}</p>
                <button
                    onClick={() => setShowModal(false)}
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                    بستن
                </button>
            </div>
        </div>
    )} */}
</div>
  )
}

export default Crawler
